import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '..//../../app-context';
import IGridComponent from '..//../../components/grid/i-grid.component';
import TitlePanel from '..//../../components/title-panel/title-panel.component';
import { EMPTY_STRING, PAGE_SIZE } from '..//../common/constants';
import { isEmptyArray } from '..//../common/util.services';
import './user-list.component.scss';
import { getAllUsers } from '..//./user.services';

const UserList = () => {
  const appContext = useContext(AppContext);
  const navigate = useNavigate();
  const rows: GridRowsProp = [];
  const columns: GridColDef[] = [
    { field: 'name', headerName: 'Name', filterable: false, sortable: false, editable: false, width: 220 },
    { field: 'userId', headerName: 'Mobile Number', filterable: false, sortable: false, editable: false, width: 150 },
    { field: 'lfhMailId', headerName: 'LFH Mail Id', filterable: false, sortable: false, editable: false, width: 200 },
    { field: 'gmailId', headerName: 'Gmail Id', filterable: false, sortable: false, editable: false, width: 200 },
    { field: 'designation', headerName: 'Designation', filterable: false, sortable: false, editable: false, width: 250 },
    { field: 'role', headerName: 'Role', filterable: false, sortable: false, editable: false, width: 150 },
    { field: 'isActive', headerName: 'Active', filterable: false, sortable: false, editable: false, width: 90,
      valueGetter: (value) => { return value === 1 ? 'Yes' : 'No'; }
    }
  ];
  const [role, setRole] = useState<String>('USER');
  const [userData, setUserData] = useState(rows);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    if (appContext.userData) {
      setRole(appContext.userData.role);
    }
    if (isEmptyArray(rows)) {
      getAllUsers(page, pageSize, appContext,
        (response: any) => {
          setUserData(response.data.content);
          setTotalRows(response.data.totalElements);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  }, [page, pageSize]);

  const handleEditAction = (row: any) => {
    navigate(EMPTY_STRING + row.rowId);
  };

  const addUser = () => {
    navigate('new');
  }

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }

  const getMainPanel = () => {
    return <>
      <IGridComponent title={''} rows={userData} columns={columns} loading={loading} paginationType="server" 
        paginationModelChange={onPaginationModelChange} totalRows={totalRows}
        showAction={'ADMIN' === role || 'LFHADMIN' === role} handleEditAction={handleEditAction} 
        showApproveAction={false} showDeleteAction={false} getRowId={(row: any) => row.rowId} 
        showAddBtn={'ADMIN' === role || 'LFHADMIN' === role} addRow={addUser} />
    </>
  }

  return <TitlePanel title='Employees' panelBody={getMainPanel()} />
}

export default UserList;